module.exports = __webpack_public_path__ + "img/relateds-background.988d72c6.png";